import { AxiosResponse } from 'axios';
import { IScreen } from 'modules/dashboard/interfaces/api';
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { ISagaFunc } from 'services/actionConfigs';
import { PaginationResponse } from 'services/commonTypes';
import { IResponseData, getMessageError } from 'services/response';
import toast from 'utils/toast';
import { setPageLoading } from 'widgets/PageLoading';
import { IApiGetDemoDataParam, IApiGetListScreensInStoreParam, IApiGetListStoresParam, ICreateStoreRequest, IStore } from '../interfaces/api';
import { IDEMOModelResDataItem } from '../interfaces/demoData';
import actions from './actions';
import apis from './apis';

const getDemoData: ISagaFunc<IApiGetDemoDataParam> = function* () {
  try {
    const resData: AxiosResponse<{ data: IDEMOModelResDataItem[] }> = yield call(apis.getDemoData);
    if (resData?.data?.data) {
      yield put(actions.getDemoData.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getDemoData.fail({}));
  }
};

const createStore: ISagaFunc<ICreateStoreRequest> = function* ({ payload }) {
  setPageLoading(true);
  try {
    const resData: IResponseData<boolean> = yield call(apis.createStore, payload);
    if (resData?.data?.data) {
      yield put(actions.createStore.success(resData.data.data));
      toast.success('Store created successfully');
    }
  } catch (error) {
    const message = getMessageError(error);
    toast.error(message);
    yield put(actions.createStore.fail({ message }));
  } finally {
    setPageLoading(false);
  }
};

const getListStores: ISagaFunc<IApiGetListStoresParam> = function* ({ payload }) {
  try {
    setPageLoading(true);
    delay(200);
    const resData: IResponseData<PaginationResponse<IStore>> = yield call(apis.getListStores, payload);
    if (resData?.data?.data) {
      yield put(actions.getListStores.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListStores.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

const setListStoresParams: ISagaFunc<IApiGetListStoresParam> = function* ({ payload }) {
  yield put(actions.getListStores.fetch(payload));
};

const getListScreensInStore: ISagaFunc<IApiGetListScreensInStoreParam> = function* ({ payload }) {
  try {
    setPageLoading(true);
    delay(200);
    const resData: IResponseData<PaginationResponse<IScreen>> = yield call(apis.getListScreensInStore, payload);
    if (resData?.data?.data) {
      yield put(actions.getListScreensInStore.success(resData.data.data));
    }
  } catch (error) {
    yield put(actions.getListScreensInStore.fail({}));
  }
  finally {
    setPageLoading(false);
  }
};

export default function* storeServiceSagas() {
  yield takeLatest(actions.getDemoData.fetch, getDemoData);
  yield takeLatest(actions.getListStores.fetch, getListStores);
  yield takeLatest(actions.setListStoresParams, setListStoresParams);
  yield takeLatest(actions.createStore.fetch, createStore);
  yield takeLatest(actions.getListScreensInStore.fetch, getListScreensInStore);
  yield takeLatest(actions.setListStoresParams, setListStoresParams);
}
